export class User {
    email: string;
    password: string;
    confirmPassword: string;
    phone: number;
    countryCode: number;
    city: string;
    state: string;
    postalCode: string;
    bio: string;
    firstName: string;
    lastName: string;
    country: string;
    timeZone: string;
    type?: number;
    status?: string;
    profile_image?: string;
}